import * as React from 'react';

// PACKAGES
import 'moment/locale/en-au';
import { Tooltip } from 'reactstrap';

// COMPONENTS
import DisplayDate from './DisplayDate';
import StatusIcon from './StatusIcon';
import DisplayDateTime from './DisplayDateTime';

// UTILS
import { WWCCStyleDisplay, WWCCTextDisplay } from '../utils';

// ICONS
import { ReactComponent as DownloadIcon } from '../assets/svg/download.svg';
import { ReactComponent as InfoIcon } from '../assets/svg/Information.svg';

// TYPES
import { AccountExistingCertificationsCertification, DomainCertificationType } from '../api/models';
import { connect, ErrorMessage, Field, FieldArray } from 'formik';

interface ExistingCertificationTypes {
	existingCertifications?: AccountExistingCertificationsCertification[];
	existingTeacherRegistration?: AccountExistingCertificationsCertification[];
	existingWWCCRegistration?: AccountExistingCertificationsCertification[];
	formik?: any;
}

const ExistingCertification: React.FC<ExistingCertificationTypes> = ({
	existingCertifications,
	formik,
	existingTeacherRegistration,
	existingWWCCRegistration
}) => {
	const hasValidWWCC =
		existingWWCCRegistration && existingWWCCRegistration.filter((item) => item.validCertification).length > 0;

	const hasValidTR =
		existingTeacherRegistration && existingTeacherRegistration.filter((item) => item.validCertification).length > 0;

	const hasValidCertificate = hasValidWWCC || hasValidTR;

	React.useEffect(() => {
		setTimeout(() => {
			hasValidCertificate && formik.setFieldValue('hasValidExisitingCertificate', true);

			hasValidWWCC && formik.setFieldValue('hasValidExisitingWWCCCertificate', true);

			hasValidTR && formik.setFieldValue('hasValidExisitingTRCertificate', true);

			if (formik.values.existingTeacherRegistration)
				formik.values.existingTeacherRegistration.map((x: any, index: any) => {
					if (x.validCertification === false)
						formik.setFieldValue(`existingTeacherRegistration[${index}].teacherReg`, true);
				});

			if (formik.values.existingWWCCRegistration)
				formik.values.existingWWCCRegistration.map((x: any, index: any) => {
					if (x.validCertification === false) formik.setFieldValue(`existingWWCCRegistration[${index}].WWCCReg`, true);
				});
		}, 1);
	}, []);

	// WWCC API Logic
	const [adminTooltipOpen, setAdminTooltipOpen] = React.useState<{ [key: number]: boolean }>({});
	const toggleAdminTooltip = (idx: number) => {
		setAdminTooltipOpen((prev) => ({ ...prev, [idx]: !prev[idx] }));
	};

	return (
		<>
			<div className="sub-purple-text form-group">
				We have detected your ChildAware account already contains the following document
				{existingCertifications && existingCertifications.concat(existingCertifications).length > 1 ? 's' : null}.
			</div>

			<div className="general-divider"></div>

			{existingCertifications &&
				existingCertifications.length > 0 &&
				existingCertifications
					.filter(
						(item) =>
							item.certificationType !== DomainCertificationType.WorkingWithChildrenCheck &&
							item.certificationType !== DomainCertificationType.TeacherRegistration
					)
					.map((item, index) => {
						return (
							<div
								key={index}
								className={!item.validCertification ? 'existing-certification disabled' : 'existing-certification'}
							>
								<div className="existing-container">
									{item.validCertification ? <StatusIcon statusType="success" /> : <StatusIcon statusType="danger" />}

									<div className="existing-text-group">
										<p>
											{item.name}
											{!item.validCertification && <span className="text-danger"> (Expired)</span>}
										</p>

										{item.certificationNumber && <p>#{item.certificationNumber}</p>}

										<p>
											{item.state && `${item.state}, `}
											{item.expiry && <DisplayDate>{item.expiry}</DisplayDate>}
											{item.date && <DisplayDate>{item.date}</DisplayDate>}
										</p>

										{item.attachments && item.attachments.length > 0 && (
											<div className="attachment-container">
												<h2 className="attachment-heading">Attachments</h2>

												<ul>
													{item.attachments.map((document, index) => {
														return (
															<li key={index}>
																<a className="attachments-download-link" href={document.link} download>
																	<span className="link-name">{document.fileName}</span>

																	<span className="link-text d-none d-lg-block">Download</span>

																	<DownloadIcon className="link-icon d-block d-lg-none" />
																</a>
															</li>
														);
													})}
												</ul>
											</div>
										)}
									</div>
								</div>

								<div className="general-divider"></div>
							</div>
						);
					})}

			{existingCertifications &&
				existingCertifications.length > 0 &&
				existingCertifications
					.filter((item) => {
						if (existingWWCCRegistration || existingTeacherRegistration) {
							return (
								existingWWCCRegistration?.some((existingItem) => existingItem.id !== item.id) ||
								existingTeacherRegistration?.some((existingItem) => existingItem.id !== item.id)
							);
						}

						return (
							item.certificationType === DomainCertificationType.WorkingWithChildrenCheck ||
							item.certificationType === DomainCertificationType.TeacherRegistration
						);
					})
					.map((item, index) => {
						return (
							<div
								key={index}
								className={!item.validCertification ? 'existing-certification disabled' : 'existing-certification'}
							>
								<div className="existing-container">
									{item.validCertification ? <StatusIcon statusType="success" /> : <StatusIcon statusType="danger" />}

									<div className="existing-text-group">
										<p>
											{item.name}
											{!item.validCertification && <span className="text-danger"> (Expired)</span>}
										</p>

										{item.certificationNumber && <p>#{item.certificationNumber}</p>}

										<p>
											{item.state && `${item.state}, `}
											{item.expiry && <DisplayDate>{item.expiry}</DisplayDate>}
											{item.date && <DisplayDate>{item.date}</DisplayDate>}
										</p>

										{item.attachments && item.attachments.length > 0 && (
											<div className="attachment-container">
												<h2 className="attachment-heading">Attachments</h2>

												<ul>
													{item.attachments.map((document, index) => {
														return (
															<li key={index}>
																<a className="attachments-download-link" href={document.link} download>
																	<span className="link-name">{document.fileName}</span>

																	<span className="link-text d-none d-lg-block">Download</span>

																	<DownloadIcon className="link-icon d-block d-lg-none" />
																</a>
															</li>
														);
													})}
												</ul>
											</div>
										)}
									</div>
								</div>

								<div className="general-divider"></div>
							</div>
						);
					})}

			<FieldArray name="existingTeacherRegistration">
				{(props) => {
					const { push, remove, form } = props;
					const { values } = form;
					const { existingTeacherRegistration } = values;
					return (
						<>
							{existingTeacherRegistration &&
								existingTeacherRegistration.map((item: any, index: number) => {
									return (
										<div
											key={index}
											className={
												!item.validCertification ? 'existing-certification disabled' : 'existing-certification'
											}
										>
											<div className="existing-container">
												{item.validCertification ? (
													<StatusIcon statusType="success" />
												) : (
													<StatusIcon statusType="danger" />
												)}

												<div className="existing-text-group">
													<p>
														{item.name}
														{!item.validCertification && <span className="text-danger"> (Expired)</span>}
													</p>

													{item.certificationNumber && <p>#{item.certificationNumber}</p>}

													<p>
														{item.state && `${item.state}, `}
														{item.expiry && <DisplayDate>{item.expiry}</DisplayDate>}
														{item.date && <DisplayDate>{item.date}</DisplayDate>}
													</p>

													{item.attachments && item.attachments.length > 0 && (
														<div className="attachment-container">
															<h2 className="attachment-heading">Attachments</h2>

															<ul>
																{item.attachments.map((document: any, index: number) => {
																	return (
																		<li key={index}>
																			<a className="attachments-download-link" href={document.link} download>
																				<span className="link-name">{document.fileName}</span>

																				<span className="link-text d-none d-lg-block">Download</span>

																				<DownloadIcon className="link-icon d-block d-lg-none" />
																			</a>
																		</li>
																	);
																})}
															</ul>
														</div>
													)}

													{formik.values.existingTeacherRegistration[index].validCertification ? (
														<div className="form-group acknowledge-container mbtom-0">
															<label className="form-control-checkbox">
																<Field
																	name={`existingTeacherRegistration[${index}].teacherReg`}
																	type="checkbox"
																	onChange={() => {
																		const checked = !formik.values.existingTeacherRegistration[index].teacherReg;

																		formik.setFieldValue(`existingTeacherRegistration[${index}].teacherReg`, checked);
																	}}
																	checked={formik.values.existingTeacherRegistration[index].teacherReg}
																/>

																<span>
																	I have notified the teacher registration authority that I am working or volunteering
																	at this organisation
																</span>
															</label>

															<ErrorMessage name={`existingTeacherRegistration[${index}].teacherReg`}>
																{(error) => <div className="form-validation-error">{error}</div>}
															</ErrorMessage>
														</div>
													) : null}
												</div>
											</div>

											<div className="general-divider"></div>
										</div>
									);
								})}
						</>
					);
				}}
			</FieldArray>

			<FieldArray name="existingWWCCRegistration">
				{(props) => {
					const { push, remove, form } = props;
					const { values } = form;
					const { existingWWCCRegistration } = values;

					return (
						<>
							{existingWWCCRegistration &&
								existingWWCCRegistration.map((item: any, index: number) => {
									const tooltipId = `wwcc-tooltip-${index}`;

									return (
										<div
											key={index}
											className={
												!item.validCertification ? 'existing-certification disabled' : 'existing-certification'
											}
										>
											<div className="existing-container">
												{item.validCertification ? (
													<StatusIcon statusType="success" />
												) : (
													<StatusIcon statusType="danger" />
												)}

												<div className="existing-text-group">
													<p>
														{item.name}
														{!item.validCertification && <span className="text-danger"> (Expired)</span>}
													</p>

													{item.certificationNumber && <p>#{item.certificationNumber}</p>}

													<p>
														{item.state && `${item.state}, `}
														{item.expiry && <DisplayDate>{item.expiry}</DisplayDate>}
														{item.date && <DisplayDate>{item.date}</DisplayDate>}
													</p>

													{item.canDisplayWWCCCheckStatus ? (
														<div className="d-flex justify-content-between flex-wrap mt-3 mb-2 gap-1">
															<div className="d-flex justify-content-start align-items-center flex-grow-1 gap-3">
																<p className={`body-medium ${WWCCStyleDisplay(item.wwccEligibleToWork)}`}>
																	Eligible to work: {WWCCTextDisplay(item.wwccEligibleToWork)}
																</p>

																{item.wwccMessage ? (
																	<>
																		<InfoIcon className="info-icon mt-0" id={tooltipId} />

																		<Tooltip
																			placement="top"
																			isOpen={!!adminTooltipOpen[index]}
																			autohide={false}
																			target={tooltipId}
																			toggle={() => toggleAdminTooltip(index)}
																		>
																			<div className="tooltip-content">{item.wwccMessage}</div>
																		</Tooltip>
																	</>
																) : null}
															</div>

															<div className="d-flex align-items-center gap-2">
																<p className="body-medium text-grey-4 mb-0">Last checked:</p>

																<p className={`body-medium ml-1 mb-0 ${WWCCStyleDisplay(item.wwccEligibleToWork)}`}>
																	{item.wwccLastChecked ? (
																		<DisplayDateTime format="DD/MM/YYYY, hh:mma">
																			{item.wwccLastChecked}
																		</DisplayDateTime>
																	) : (
																		<>Not checked yet</>
																	)}
																</p>
															</div>
														</div>
													) : null}

													{/* Attachments */}
													{item.attachments && item.attachments.length > 0 && (
														<div className="attachment-container">
															<h2 className="attachment-heading">Attachments</h2>

															<ul>
																{item.attachments.map((document: any, index: number) => {
																	return (
																		<li key={index}>
																			<a className="attachments-download-link" href={document.link} download>
																				<span className="link-name">{document.fileName}</span>

																				<span className="link-text d-none d-lg-block">Download</span>

																				<DownloadIcon className="link-icon d-block d-lg-none" />
																			</a>
																		</li>
																	);
																})}
															</ul>
														</div>
													)}

													{formik.values.existingWWCCRegistration[index].validCertification ? (
														<div className="form-group acknowledge-container mbtom-0">
															<label className="form-control-checkbox">
																<Field
																	name={`existingWWCCRegistration[${index}].WWCCReg`}
																	type="checkbox"
																	onChange={() => {
																		const checked = !formik.values.existingWWCCRegistration[index].WWCCReg;

																		formik.setFieldValue(`existingWWCCRegistration[${index}].WWCCReg`, checked);
																	}}
																	checked={formik.values.existingWWCCRegistration[index].WWCCReg}
																/>

																<span>
																	I have notified the Working with Children Check authority that I am working or
																	volunteering at this organisation.
																</span>
															</label>

															<ErrorMessage name={`existingWWCCRegistration[${index}].WWCCReg`}>
																{(error) => <div className="form-validation-error">{error}</div>}
															</ErrorMessage>
														</div>
													) : null}
												</div>
											</div>

											<div className="general-divider"></div>
										</div>
									);
								})}
						</>
					);
				}}
			</FieldArray>
		</>
	);
};

export default connect(ExistingCertification);
